import { render, staticRenderFns } from "./PreguntasFrecuentes.vue?vue&type=template&id=4839fa4e"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=js"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports